<template>
  <div class="search-events-form card">
    <el-form :rules="rules" :model="formData" label-position="top" ref="form" @submit.prevent="">
      <div class="search-events-form__default">
        <div class="row">
          <div class="col col-xs-12 col-md-6">
            <el-form-item label="Activity" prop="activityId" :error="errors.activityId">
              <el-select class="wide" v-model="formData.activityId" placeholder="Choose from the list"
                @change="handleChangeActivity">
                <el-option label="Any" :value="''" />
                <el-option v-for="type in descriptions.activityType" :key="type.value" :label="type.description"
                  :value="type.value">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="col col-xs-12 col-md-6">
            <el-form-item label="Type" prop="activityEventTypeId" :error="errors.activityEventTypeId">
              <el-select class="wide" v-model="formData.activityEventTypeId" placeholder="Choose from the list"
                :disabled="!isActivityChosen">
                <el-option label="Any" :value="''" />
                <el-option v-for="type in activityEventTypeDescriptions" :key="type.value" :label="type.description"
                  :value="type.value">
                </el-option>
              </el-select>
            </el-form-item>
          </div>

          <div class="col col-xs-12">
            <p class="search-events-form__subtitle">
              Start date
            </p>
          </div>
          <div class="col col-xs-12 col-md-6">
            <el-form-item label="From" prop="startDateFrom" :error="errors.startDateFrom">
              <el-date-picker class="wide" v-model="formData.startDateFrom" type="date" format="DD/MM/YYYY">
              </el-date-picker>
            </el-form-item>
          </div>
          <div class="col col-xs-12 col-md-6">
            <el-form-item label="To" prop="startDateTo" :error="errors.startDateTo">
              <el-date-picker class="wide" v-model="formData.startDateTo" type="date" format="DD/MM/YYYY">
              </el-date-picker>
            </el-form-item>
          </div>

          <div class="col col-xs-12">
            <p class="search-events-form__subtitle">
              End date
            </p>
          </div>
          <div class="col col-xs-12 col-md-6">
            <el-form-item label="From" prop="endDateFrom" :error="errors.endDateFrom">
              <el-date-picker class="wide" v-model="formData.endDateFrom" type="date" format="DD/MM/YYYY">
              </el-date-picker>
            </el-form-item>
          </div>
          <div class="col col-xs-12 col-md-6">
            <el-form-item label="To" prop="endDateTo" :error="errors.endDateTo">
              <el-date-picker class="wide" v-model="formData.endDateTo" type="date" format="dd/mm/yyyy">
              </el-date-picker>
            </el-form-item>
          </div>

          <div class="col col-xs-12 col-md-5">
            <el-form-item label="Status" prop="status" :error="errors.status">
              <el-select class="wide" v-model="formData.status" placeholder="Choose from the list">
                <el-option label="Any" :value="''" />
                <el-option v-for="type in eventStatusDescriptions" :key="type.value" :label="type.description"
                  :value="type.value">
                </el-option>
              </el-select>
            </el-form-item>
          </div>

          <div class="col col-xs-12 col-md-2">
            <el-form-item label="Within" prop="distance" :error="errors.distance">
              <el-input v-model="formData.distance" />
            </el-form-item>
          </div>
          <div class="col col-xs-12 col-md-2">
            <el-form-item label="units" prop="distanceUnit" :error="errors.distanceUnit">
              <el-select class="wide" v-model="formData.distanceUnit" placeholder="Choose from the list">
                <el-option v-for="unit in distanceUnits" :key="unit" :label="unit" :value="unit">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="col col-xs-12 col-md-3">
            <el-form-item label="from" prop="location" :error="errors.location">
              <el-input v-model="formData.location" />
            </el-form-item>
          </div>
          <div class="col col-xs-12 col-md-5">
            <el-checkbox v-model="formData.withOpenVacancies">With open vacancies only</el-checkbox>
          </div>
        </div>
      </div>

      <div class="search-events-form__extended" v-if="searchType === 1">
        <p class="search-events-form__subtitle">Level</p>
        <div class="row">
          <div class="col col-xs-12 col-md-6">
            <el-form-item label="Not easier than" prop="eventLevelTypeFrom" :error="errors.eventLevelTypeFrom">
              <el-select class="wide" v-model="formData.eventLevelTypeFrom" placeholder="Choose from the list"
                :disabled="!isActivityChosen">
                <el-option label="Any" :value="''" />
                <el-option v-for="type in eventLevelTypeDescriptions" :key="type.value" :label="type.description"
                  :value="type.value">
                </el-option>
              </el-select>
            </el-form-item>
          </div>

          <div class="col col-xs-12 col-md-6">
            <el-form-item label="Not harder than" prop="eventLevelTypeTo" :error="errors.eventLevelTypeTo">
              <el-select class="wide" v-model="formData.eventLevelTypeTo" placeholder="Choose from the list"
                :disabled="!isActivityChosen">
                <el-option label="Any" :value="''" />
                <el-option v-for="type in eventLevelTypeDescriptions" :key="type.value" :label="type.description"
                  :value="type.value">
                </el-option>
              </el-select>
            </el-form-item>
          </div>

          <div class="col col-xs-12 col-md-6">
            <el-form-item label="Team" prop="teamId" :error="errors.teamId">
              <el-select class="wide" v-model="formData.teamId" placeholder="Choose from the list"
                :disabled="!isActivityChosen">
                <el-option label="Any" :value="''" />
                <el-option v-for="type in teamDescriptions" :key="type.value" :label="type.description"
                  :value="type.value">
                </el-option>
              </el-select>
            </el-form-item>
          </div>

          <div class="col col-xs-12 col-md-6">
            <el-form-item label="Name contains" prop="name" :error="errors.name">
              <el-input v-model="formData.name" />
            </el-form-item>
          </div>

          <div class="col col-xs-12">
            <el-form-item label="Description contains" prop="description" :error="errors.description">
              <el-input v-model="formData.description" />
            </el-form-item>
          </div>
        </div>
      </div>

      <div class="search-events-form__bottom">
        <div class="search-events-form__toggler" @click="toggleSearchType">
          <el-button type="primary">{{ searchType === 0 ? 'All parameters' : 'Default search' }}
            <i :class="searchType === 0 ? 'el-icon-arrow-down' : 'el-icon-arrow-up'
              " />
          </el-button>
        </div>

        <div class="search-events-form__buttons">
          <el-button type="primary" @click="resetForm" native-type="reset"
            :disabled="isButtonDisabled('search-events')">
            Reset search
          </el-button>
          <el-button type="primary" @click="validateForm" native-type="submit"
            :disabled="isButtonDisabled('search-events')">
            Search
          </el-button>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import {
  searchEvent,
  getEventStatusToSearchDescriptions,
  getAchievementFunctionDescriptions,
  getActivityEventTypeDescriptions,
  getEventLevelTypeDescriptions,
} from '@/api/events.js';
import { getTeamDescriptions } from '@/api/team.js';
import { removeTimezoneOffset, parseErrorsByFields } from '@/utils/index.js';
import { showMessage } from '@/utils/messages.js';
import { disableButton } from '@/mixins/disableButton.js';

export default {
  name: 'SearchEventsForm',
  props: {
    skip: {
      type: Number,
      required: false,
    },
    limit: {
      type: Number,
      required: false,
    },
    all: {
      type: Boolean,
      required: false,
    },
  },
  mixins: [disableButton],
  data() {
    return {
      distanceUnits: ['km', 'mi', 'nm'],
      searchType: 0,
      formData: {
        activityId: null,
        status: null,
        activityEventTypeId: null,
        name: null,
        startDateFrom: null,
        startDateTo: null,
        endDateFrom: null,
        endDateTo: null,
        location: null,
        distanceUnit: null,
        distance: null,
        eventLevelTypeFrom: null,
        eventLevelTypeTo: null,
        description: null,
        teamId: null,
        withOpenVacancies: false,
      },
      errors: {
        activityId: '',
        status: '',
        activityEventTypeId: '',
        name: '',
        startDateFrom: '',
        startDateTo: '',
        endDateFrom: '',
        endDateTo: '',
        location: '',
        distance: '',
        distanceUnit: '',
        eventLevelTypeFrom: '',
        eventLevelTypeTo: '',
        description: '',
        teamId: '',
        withOpenVacancies: '',
      },
      rules: {
        activityId: [{ required: false, trigger: 'blur', message: '' }],
        status: [{ required: false, trigger: 'blur', message: '' }],
        activityEventType: [{ required: false, trigger: 'blur', message: '' }],
        name: [{ required: false, trigger: 'blur', message: '' }],
        startDateFrom: [{ required: false, trigger: 'blur', message: '' }],
        startDateTo: [{ required: false, trigger: 'blur', message: '' }],
        endDateFrom: [{ required: false, trigger: 'blur', message: '' }],
        endDateTo: [{ required: false, trigger: 'blur', message: '' }],
        location: [{ required: false, trigger: 'blur', message: '' }],
        distance: [{ required: false, trigger: 'blur', message: '' }],
        distanceUnit: [{ required: false, trigger: 'blur', message: '' }],
        eventLevelTypeFrom: [{ required: false, trigger: 'blur', message: '' }],
        eventLevelTypeTo: [{ required: false, trigger: 'blur', message: '' }],
        description: [{ required: false, trigger: 'blur', message: '' }],
        teamId: [{ required: false, trigger: 'blur', message: '' }],
        withOpenVacancies: [{ required: false, trigger: 'blur', message: '' }],
      },

      eventStatusDescriptions: [],
      activityEventTypeDescriptions: [],
      eventLevelTypeDescriptions: [],
      teamDescriptions: [],
    };
  },
  computed: {
    searchFormData() {
      const { skip, limit, searchType, all } = this;
      const {
        activityId,
        status,
        activityEventTypeId,
        name,
        startDateFrom,
        startDateTo,
        endDateFrom,
        endDateTo,
        eventLevelTypeFrom,
        eventLevelTypeTo,
        location,
        distance,
        distanceUnit,
        description,
        teamId,
        withOpenVacancies,
      } = this.formData;

      const data = {
        skip,
        limit,
        all,
        filterModel: {
          activityId,
          status,
          activityEventTypeId,
          name,
          startDate: {
            from: startDateFrom
              ? this.removeTimezoneOffset(startDateFrom)
              : null,
            to: endDateTo ? this.removeTimezoneOffset(endDateTo) : null,
          },
          endDate: {
            from: endDateFrom ? this.removeTimezoneOffset(endDateFrom) : null,
            to: endDateTo ? this.removeTimezoneOffset(endDateTo) : null,
          },
          location,
          distance,
          distanceUnit,
          eventLevelType: {
            from: eventLevelTypeFrom,
            to: eventLevelTypeTo,
          },
          description,
          teamId: teamId,
          withOpenVacancies,
        },
      };

      return data;
    },
    descriptions() {
      return this.$store.state.descriptions;
    },
    isActivityChosen() {
      const { activityId } = this.formData;

      return activityId !== null;
    },
  },
  // watch: {
  //   skip() {
  //     this.fetchEvents();
  //   },
  //   limit() {
  //     this.fetchEvents();
  //   },
  // },
  methods: {
    removeTimezoneOffset,
    parseErrorsByFields,
    showMessage,
    async fetchEvents() {
      this.disableButton('search-events');
      const { searchFormData } = this;
      const { data, success, errors } = await searchEvent(searchFormData);
      this.enableButton('search-events');

      if (success) {
        this.$emit('receive-data', data);
      } else if (errors) {
        this.errors = { ...this.errors, ...this.parseErrorsByFields(errors) };
      }
    },
    async fetchEventStatusToSearchDescriptions() {
      const { data, success } = await getEventStatusToSearchDescriptions();

      if (success) {
        this.eventStatusDescriptions = data.items;
      }
    },
    async fetchActivityEventTypeDescriptions() {
      const { activityId } = this.formData;
      const { data, success } = await getActivityEventTypeDescriptions({
        activityId,
      });

      if (success) {
        this.activityEventTypeDescriptions = data.items;
      }
    },
    async fetchEventLevelTypeDescriptions() {
      const { activityId } = this.formData;
      const { data, success } = await getEventLevelTypeDescriptions({
        activityId,
      });

      if (success) {
        this.eventLevelTypeDescriptions = data.items;
      }
    },
    async fetchTeamDescriptions() {
      const { activityId } = this.formData;
      const { data, success } = await getTeamDescriptions({
        activityId,
      });

      if (success) {
        this.teamDescriptions = data.items;
      }
    },
    validateForm() {
      this.fetchEvents();
    },
    toggleSearchType() {
      this.searchType = this.searchType === 0 ? 1 : 0;
    },
    handleDescriptions() {
      const { isActivityChosen } = this;

      if (isActivityChosen) {
        this.fetchActivityEventTypeDescriptions();
        this.fetchEventLevelTypeDescriptions();
        this.fetchTeamDescriptions();
      }
    },
    handleChangeActivity() {
      this.formData.activityEventTypeId = null;
      this.formData.eventLevelType = null;
      this.formData.teamId = null;

      this.handleDescriptions();
    },
    resetForm() {
      for (const key in this.formData) {
        this.formData[key] = key === 'status' ? 2 : null;
      }
      this.$emit('reset-data');
    },
  },
  async created() {
    await this.fetchEventStatusToSearchDescriptions();
    this.formData.status = null; //this.eventStatusDescriptions[0].value;
  },
  watch: {
    skip() {
      this.fetchEvents();
    },
    limit() {
      this.fetchEvents();
    },
  },
};
</script>

<style lang="scss">
@import '~@/styles/shared/_globals.scss';

.search-events-form {
  &__default {}

  &__extended {}

  &__bottom {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
  }

  &__toggler {}

  &__buttons {}

  &__subtitle {
    margin-top: 0;
  }
}
</style>
